import "./index.less";

import { FC } from "react";

import HeaderContent from "@/layout/components/header-content";
import SideMenu from "@/layout/components/side-menu";
import SubMenu from "./components/sub-menu";

import UserInfoDrawer from "./components/userinfo-drawer";

const oldStyle = {
    left: 130,
};

const LrLayout: FC = (props) => {
    const { children } = props;
    const isOldMenu = localStorage.getItem("crmUserMenu") === "?old=true";

    return (
        <div className={`lr-layout-box`}>
            {/* 左侧菜单 */}
            <SideMenu />
            <div className="lr-layout-box-right" style={isOldMenu ? oldStyle : {}}>
                {/* 右侧头部 */}
                <HeaderContent oldMenu={isOldMenu} />
                <div
                    className={`lr-layout-left-side-box`}
                >
                    <SubMenu />
                    {children}
                    {/* <UserInfoDrawer /> */}
                </div>
            </div>

        </div>
    );
};

export default LrLayout;
